<template>
    <div :class="$style.header">
        <!--<i @click="$router.push('/SupplyChain')" class="el-icon-back"></i>-->
        <div> </div>
        <h2>添加商品</h2>
        <el-input placeholder="请输入型号" v-model="keyword" @change="getProducts(keyword)">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
    </div>
</template>

<script>
import { getProducts, host } from '../../stores/api';
import { state } from '../../stores/request';
    export default {
        data () {
            return {
                keyword: '',
            }
        },
        beforeMount () {
            this.getProducts();
        },
        methods: {
            async getProducts (params) {
                return getProducts({keyword:params})
                .then(res=>{
                    let {navigator_list, goods_list, filter_attr, pages} = res.data;
                    goods_list = goods_list.map(item => {
                        let {goods_thumb, shop_price} = item;
                        shop_price = Number(shop_price.replace('￥', '').replace('元', ''));
                        goods_thumb = host + '/' + goods_thumb;
                        return Object.assign(item, {amount: 0, goods_thumb, shop_price});
                    });
                    this.$store.state.productList=res.data.goods_list
                })
            }
        }
    }
</script>

<style lang="less" module>
    .header {
        display: flex;
        align-items: center;
        font-size: 16px;
        & > i {
            flex: 0.3;
            color: rgba(156, 162, 173, 0.68);
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            &:hover {
                color: #9ca2ad;
            }
        }
        & > h2 {
            flex: 0.4;
            text-align: center;
        }
        & > div {
            flex: 0.3;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/AddPro/Header.vue